var map = {
	"./20231217_132117.jpg": 3496,
	"./ANAS KHAN.jpg": 2021,
	"./AanandPC.jpg": 6269,
	"./AchalPC.jpg": 38,
	"./AkagraPC.jpg": 3679,
	"./Akhil.jpg": 948,
	"./AnanyaPC.jpg": 5107,
	"./AnchalPC.jpg": 4301,
	"./AnubhavPC.jpg": 9580,
	"./ArthPC.jpg": 9086,
	"./Ayush2PC.jpg": 7525,
	"./AyushAgrawalPC.jpg": 2352,
	"./HarshPC.jpg": 6562,
	"./Lakshay.jpg": 2864,
	"./LishaPC.jpg": 7646,
	"./ManasPC.jpg": 1803,
	"./MeetPC.jpg": 9943,
	"./Megha.jpg": 6051,
	"./Mittal-.jpg": 6934,
	"./Mohitpc.jpg": 963,
	"./Mr.Mittal.jpg": 3161,
	"./Paras.jpg": 6241,
	"./RachitPC.jpg": 3734,
	"./RitikPC.jpg": 6962,
	"./SachiPC.jpg": 4189,
	"./SaumyaPC.jpg": 3528,
	"./ShambhaviPC.jpg": 3057,
	"./ShreyaaPC.jpg": 3314,
	"./ShreyanshPC.jpg": 5921,
	"./ShwetaPC.jpg": 3006,
	"./Siddharth2PC.jpg": 4140,
	"./TanishaPC.jpg": 2731,
	"./icpc1.jpg": 9948,
	"./icpc2.jpg": 7289,
	"./icpc3.jpg": 7111,
	"./rachit2PC..jpg": 7620
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9667;
module.exports = webpackAsyncContext;